// WebsiteCheckModal.jsx
import React from "react";
import "./WebsiteCheckModal.css";

export default function WebsiteCheckModal({ open, onClose }) {
  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();

    // Later you can connect API / email / backend here
    alert("Form submitted successfully!");
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <h2>Check Your Website health</h2>

        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Full Name" required />
          <input type="tel" placeholder="Phone Number" required />
          <input type="email" placeholder="Email Address" required />
          <input type="url" placeholder="Website URL" required />
          <textarea placeholder="Address" rows="3" required />

          <button type="submit">Submit</button>
        </form>

        <button className="modal-close" onClick={onClose}>✕</button>
      </div>
    </div>
  );
}
